import React, { useCallback } from 'react';

import { Box, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { Pagination as MuiPagination } from '@material-ui/lab';
import { SelectOption, UncontrolledSelect } from '../Select';

const useStyles = makeStyles((theme: Theme) => ({
  select: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    marginBottom: 0,
    height: '2.5rem',
    width: '100px',
    border: 'none',
  },
  centerItems: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: ' center',
  },
  label: {
    marginRight: '1rem',
  },
  paginationRoot: {
    margin: '12px auto',
    '& .MuiPaginationItem-page.Mui-selected': {
      backgroundColor: '#f74f00',
      color: 'white',
    },
  },
}));

interface PaginationProps {
  count: number;
  currentPage: number;
  rowsPerPage?: number;
  onChange: (event: React.ChangeEvent<unknown>, page: number) => void;
  onChangeRowsPerPage: (rowsPerPage: number) => void;
}

const ROWS_PER_PAGE: SelectOption[] = [
  { label: '20', value: 20 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
];

const Pagination = ({
  count,
  currentPage,
  rowsPerPage = 20,
  onChange,
  onChangeRowsPerPage,
}: PaginationProps) => {
  const classes = useStyles();

  const handleOnChange = useCallback(
    (e: React.ChangeEvent<{ name?: string; value: unknown }>) => {
      const option = e.target.value;

      onChangeRowsPerPage(option as number);
    },
    [onChangeRowsPerPage]
  );

  return (
    <Grid container>
      <Grid item xs={3}>
        <Box display="flex">
          <Typography className={`${classes.label} ${classes.centerItems}`}>
            Linhas por página:
          </Typography>
          <UncontrolledSelect
            className={classes.select}
            defaultValue={rowsPerPage}
            fullWidth
            name="rowsPerPage"
            options={ROWS_PER_PAGE}
            onChange={handleOnChange}
          />
        </Box>
      </Grid>
      <Grid className={classes.centerItems} item xs={8}>
        <Box alignItems="center" display="flex" justifyContent="center">
          <MuiPagination
            classes={{ root: classes.paginationRoot }}
            count={Math.ceil(count / rowsPerPage)}
            page={currentPage}
            onChange={onChange}
            showFirstButton
            showLastButton
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default Pagination;
